var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M956.9 0H67.1A67.1 67.1 0 000 67.09v889.78A67.13 67.13 0 0067.1 1024h889.8a67.13 67.13 0 0067.1-67.13V67.09A67.1 67.1 0 00956.9 0zM640 595v233.66H383.29l1.46-232.91h-167L512 311.31l299.38 281.52zm188.66-306.3H195.34v-93.37h633.32z" } }] }, name: "top", theme: "filled" };
export {
  l as default
};
